import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio";
import ReviewsSection from "./components/ReviewsSection";
import Footer from "./components/Footer";
import SpinWheel from "./components/SpinWheel";
import BookingForm from "./components/BookingForm";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Packages from "./pages/Packages";
import Reviews from "./pages/Reviews";
import AdminDashboard from "./pages/AdminDashboard";
import Music from "./pages/Music";
import DJBooking from "./pages/DJBooking";
import DJAdmin from "./pages/DJAdmin";

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/7835b5me_new%20logoo.PNG";

const Home = () => {
  return (
    <>
      <SpinWheel />
      <Hero logoUrl={LOGO_URL} />
      <Portfolio />
      <ReviewsSection limit={3} />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#050505]">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/book" element={<BookingForm />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/dj" element={<Music />} />
            <Route path="/music" element={<Music />} />
            <Route path="/dj/book" element={<DJBooking />} />
            <Route path="/dj/admin" element={<DJAdmin />} />
          </Routes>
          <Footer />
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#0a0a0a',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#ededed'
              }
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
